import React from 'react';
import {connect} from "react-redux";
import {Modal} from "bootstrap";
import { toast } from 'react-toastify';
import HttpAPICall from "../../../services/HttpAPICall";
import Loader from "../../../components/ui/Loader/Loader";
import tapIcon from "../../../services/TapIcon"
import TapSelect from '../../../components/ui/TapSelect';
import AppBaseComponent from '../../../components/AppBaseComponent';
import TapIcon from '../../../services/TapIcon';
import { ORG_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import Ax from "../../../components/hoc/Ax";
import swal from 'sweetalert';
import * as actions from '../../../store/actions/index';

class Holiday extends AppBaseComponent {

    constructor(props) {
        super(props);

          this.state                =          {
            list_loading            :         false,
            listingData             :         null,
            saveFormSubmitting      :         false,
        };

        this.documentTypeUrl        =   ORG_API_BASE_URL_2  + '/setting/doc_types';

    }

    componentDidMount() {
        this.getholidayListing()
        this.holidayModal         =    new Modal(document.getElementById('holidayModal'), {keyboard: false, backdrop :false});
    }

    getholidayListing             =         ()    =>  {
        this.setState({list_loading : true})
        HttpAPICall.withAthorization('GET', this.documentTypeUrl, this.props.access_token , {}, {}, (resp) => {
             this.setState({listingData  : resp.data})
        }).then(() => this.setState({list_loading: false}));
    }

    documentModalInit       =       ()      =>      {
        this.holidayModal.show()
    }

    submitholiday      =   (e)     =>      {
        e.preventDefault()
        this.setState({saveFormSubmitting: true})
        HttpAPICall.withAthorization('PUT', this.documentTypeUrl,
        this.props.access_token, null, {types : this.state.options}, (response) => {
            toast.success(response.data.msg, {position: toast.POSITION.TOP_RIGHT});
            this.holidayModal.hide();
            this.getholidayListing()
      }).then(() => this.setState({saveFormSubmitting: false}))
    }

    holidayModalJsx               =        ()             =>        {
       
        return (
            <div className="modal fade" id="holidayModal" tabIndex="-1">
                <div className="modal-dialog modal-lg  modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchAssetModalLabel">Edit Document Type</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
                        </div>
                        <div className="modal-body">
                        <form id="holidayForm" onSubmit={this.submitholiday}>
                           
                                <div className="row my-3 align-items-center">
                                    <label className="col-sm-3 col-form-label " >Name</label>
                                    <div className="col-md-9">
                                        <div>{this.state.options && this.state.options.length >= 1 &&
                                            this.state.options.map((i, index) => {
                                                return (
                                                    <div className="row">
                                                        <div className={this.state.options.length >= 1 ? "col-sm-10" : "col-sm-12"}>
                                                            <input
                                                                name={i}
                                                                type="text"
                                                                required="true"
                                                                className="form-control form-control-sm my-1"
                                                                value={i}
                                                                placeholder="Please Enter Document Type Name"
                                                                onChange={(e) => this.handleDocumentValue(e, index)}
                                                            />
                                                        </div>
                                                        {this.state.options.length > 2 ?
                                                            <div className="col-sm-2"><button className="btn btn-secondary my-1" onClick={this.handleDeleteOption(index)}>X</button></div> : null}
                                                    </div>
                                                )
                                            })}
                                            <div className="link-primary text-end cursor_pointer" onClick={this.addOption}>Add New Document Type</div>
                                        </div>
                                    </div>
                                </div>

                           
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" disabled={this.state.saveFormSubmitting ? true : false}>Close</button>
                                <button type="submit" className="btn btn-primary" disabled={this.state.saveFormSubmitting ? true : false}>Save {this.state.saveFormSubmitting ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}</button>
                            </div>
                        </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {

        return (
            <section className="container-fluid" style={{ padding: "0px 12px" }}>
                <div className=" row bg-white p-2">
                    <div className="col-sm-12">
                    <div className="tab_content_wrapper mt-2"><span className="content_heading">Holiday</span>
                            <div className="text-end "><button className="btn btn-primary">Add</button></div>
                        </div>
                        <table className="table table-hover table-bordered my-4 table-sm ">
                            <thead className="table-secondary">
                                <tr className="text-center">
                                    <th scope="col" style={{ width: "10%" }}>S.No</th>
                                    <th scope="col" style={{ width: "20%" }}>Date</th>
                                    <th scope="col" className="text-start"> Description</th>
                                    <th scope="col" style={{ width: "10%" }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className='text-center'>
                                    <td>1</td>
                                    <td>02-Jun-2021</td>
                                    <td  className="text-start">Holiday</td>
                                    <td>  <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid pr10 pl10" data-bs-toggle="dropdown" href="#"
                                        role="button" aria-expanded="false" />
                                        <ul className="dropdown-menu" style={{ cursor: "pointer" }} >
                                            <li className="dropdown-item" >Edit</li>
                                        </ul>
                                        </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            {this.holidayModalJsx()}
            </section>
        );
    }
}

const mapStateToProps = state => {
    return {
        access_token            :        state.auth.access_token,
    };
};


export default connect(mapStateToProps)(Holiday);